<div class="inputHeader-induxtry" *ngIf="textInput?.label">
    <span class="firstLabel" [ngStyle]="textInput?.styleLabel">
        {{ textInput.label }}
        <span *ngIf="!textField && textInput?.subLabel" class="optionalLabel" [ngStyle]="textInput?.styleSubLabel">{{textInput?.subLabel}}</span>
        <tooltip class="icon_tooltip" [tooltip]="{ text: textInput?.iconTooltip?.text, position: textInput?.iconTooltip?.position ? textInput?.iconTooltip?.position :'below' }">
            <mat-icon [svgIcon]="textInput?.iconTooltip?.icon"></mat-icon>
          </tooltip>
    </span>
    <span class="inputLength" *ngIf="!textField && textInput?.maxLength" [ngStyle]="textInput?.styleMaxLength">({{ inputValue.value.length }}/{{textInput?.maxLength}})</span>
</div>
<mat-form-field warningInputInduxtry [warning]="warning" [required]="textInput?.required" class="custom-input" [floatLabel]="'always'" appearance="outline"
[ngClass]="{
    'custom-outline-text-field': textField
}"
>
        <input #inputValue matInput [placeholder]="textInput.placeholder" type="text" [(ngModel)]="textInput.value" [required]="textInput?.required?.active"
            [disabled]="textInput.disabled" [readonly]="textInput.readonly || textField" [maxlength]="textInput?.maxLength" (ngModelChange)="setValue()" (change)="setValueOnChange()" (focusout)="handleFocusOut()">

            @if(textInput?.icon) {
                <button class="button-input-icon" mat-icon-button matSuffix>
                    <mat-icon [svgIcon]="textInput.icon"></mat-icon>
                </button>
            }
</mat-form-field>
